module.exports = __webpack_public_path__ + "img/logo_white.12345cc9.png";